import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full bg-gradient-to-b from-cream to-lavender-light/20 py-24 px-6 md:px-8" style={{
    paddingTop: '70px',
    paddingBottom: '70px'
  }} data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-lavender/30" data-id="element-221">
          <div className="p-8 md:p-12 text-center" style={{
          paddingTop: '20px',
          paddingBottom: '20px',
          paddingLeft: '25px',
          paddingRight: '25px'
        }} data-id="element-222">
            <h3 className="text-2xl font-bold text-text mb-2" data-id="element-223">
              Plan de Supervivencia Postparto
            </h3>
            <p className="text-text-light mb-8" data-id="element-224">Acceso digital inmediato</p>

            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-225">
              <span className="text-6xl font-bold text-text" data-id="element-226">$6.39</span>
              <span className="text-xl text-text-light self-end mb-2" data-id="element-227">USD</span>
            </div>

            <p className="text-lg text-text/80 mb-8 max-w-md mx-auto" data-id="element-228">
              "Lo puse en $6.39 para que no tengas que pensarlo demasiado.
              Porque si estás en posparto, lo último que necesitas es otra
              decisión grande."
            </p>

            <div className="bg-cream p-4 rounded-xl mb-8 inline-block" style={{
            paddingLeft: '50px',
            paddingRight: '50px'
          }} data-id="element-229">
              <p className="font-medium text-text" data-id="element-230">
                Lo abro ahora. Hago el Día 1. Respiro.
              </p>
            </div>

            <a href="#offer-price" className="w-full md:w-auto inline-flex items-center justify-center gap-3 bg-lavender-dark hover:bg-text text-white px-8 py-4 rounded-full text-xl font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 mb-6" style={{
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '15px',
            paddingRight: '15px',
            marginLeft: '10px',
            marginRight: '10px'
          }} data-id="element-231">
              Descarga el Plan
              <ArrowRight className="w-6 h-6" data-id="element-232" />
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-text-light mt-4" data-id="element-233">
              <ShieldCheck className="w-4 h-4 text-sage-dark" data-id="element-234" />
              <span data-id="element-235">
                Si no te ayuda a sentirte más sostenida en 7 días, te devuelvo
                el dinero.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}